import { Component, Input, ChangeDetectionStrategy, OnChanges,  Output, EventEmitter } from "@angular/core";
import { HttpClient, HttpBackend } from "@angular/common/http";
import { ImageCroppedEvent, ImageTransform } from "ngx-image-cropper";
import { AdminService } from "../../services/admin.service";

import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";

@Component({
  selector: "app-upload-file",
  templateUrl: "./upload-file.component.html",
  styleUrls: ["./upload-file.component.css"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UploadFileComponent implements OnChanges {
  @Input() objectProperty: any;
  @Output() valueChange = new EventEmitter();
  @Output() changeDetected: EventEmitter<any> = new EventEmitter<any>();
  // objectProp: any;
  imageUpload1;
  value: number = 0;
  options = {
    floor: 0,
    ceil: 5
  };
  loader= false;
  aspectRatio = 1 / 1;
  aspectRatio2 = 3 / 4;
  aspectRatio1 = 1 / 1;
  aspectRatio3 = 4 / 3;
  imagewidthsize;
  imageheightsize;
  cropperMinHeight;
  cropperMinWidth;
  resizeWidth;
  directory;
  imageUpload;
  image1;
  image;
  Image;
  event;
  FirstUpload= false;
  scale: number = 1.0;
  transform: ImageTransform = {};
  imageChangedEvent: any = "";
  modalRef?: BsModalRef;
  roundCropper = false;
  showOnlySquare= false;
  imageSetwidth = false;
  maintainAspectRatio = true;
  constructor(private handler: HttpBackend, private http: HttpClient, private api: AdminService, private modalService: BsModalService,private admin: AdminService) {

  }
  ngOnChanges(objectProperty: any) {
    this.directory = objectProperty.objectProperty.currentValue.directory;
    this.imagewidthsize = objectProperty.objectProperty.currentValue.imagewidthsize;
    this.roundCropper = objectProperty.objectProperty.currentValue.roundCropper;
    this.showOnlySquare = objectProperty.objectProperty.currentValue.showOnlySquare;
    this.imageheightsize = objectProperty.objectProperty.currentValue.imageheightsize;
    this.aspectRatio = objectProperty.objectProperty.currentValue.aspectRatio;
    this.upload(objectProperty.objectProperty.currentValue.event);
    this.cropperMinHeight = objectProperty.objectProperty.currentValue.cropperHeight;
    this.cropperMinWidth = objectProperty.objectProperty.currentValue.cropperMinWidth;
    this.resizeWidth = objectProperty.objectProperty.currentValue.cropperMinWidth;
    this.maintainAspectRatio = objectProperty.objectProperty.currentValue.maintainAspectRatio;
  }
  ngOnInit(): void {

  }
  // upload image
  upload(event: any): void { 
    this.event = event;
    this.imageChangedEvent = event;
    this.FirstUpload = true;
  }
  base64ToFile(data, filename) {

    const arr = data.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    let u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  zoomSlide(event) {
    this.scale = event / 10 + 1;
    this.transform = {
      ...this.transform,
      scale: this.scale
    };
  }
  Confirm() {
    // this.api.loader(true) 
    this.image1 = this.image;
    this.imageUpload = this.imageUpload1;
    this.uploadImagetoset();
    this.uploadFileToS3();
  } 
  close() {
    this.valueChange.emit({ file: "", image1: "" })
    this.api.loader(false)
    this.loader = false; 
  }
  // convert to file
  uploadImagetoset() {
    this.imageUpload = this.base64ToFile(
      this.image1,
      this.imageChangedEvent.target.files[0].name,
    )
    return this.imageUpload
  }
  // uploadFile To S3 its returm Image Link
  uploadFileToS3() {
    // this.admin.loader(true);
    // this.api.startLoader();
    const ImageName = (this.imageUpload.name.split(".")[this.imageUpload.name.split(".").length - 2] + ".jpg")
    const data = {
      "directory": this.directory,
      "fileName": ImageName,
      "contentType":this.imageUpload.type
    }// postData
    this.api.postUploadData("recruiter/v1/common/getSignedURL", data)
      .subscribe(res => {
        this.admin.loader(true)
        this.http = new HttpClient(this.handler);
        this.http.put<any>(res.data.uploadURL, this.imageUpload).subscribe(response => {
          // this.objectProp = Object.assign({}, { file: res.data.fileName, image1: this.image1 });
          this.valueChange.emit({ file: res.data.fileName, image1: this.image1 });
          this.imageUpload = res.data.fileName
          // this.api.stopLoader();
          this.admin.loader(false);
          return
        })
        // this.admin.loader(true);
        // this.imageUpload = res.data.fileName
      }) 
  }
  imageCropped(event: ImageCroppedEvent) {
    this.image = event.base64;
    this.imageUpload1 = event.base64;
    if (this.FirstUpload) {
      this.image1 = this.image;
      this.imageUpload = this.imageUpload1;
      this.FirstUpload = false
    }
  }

}